import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';


const mapStateToProps = ({locales}) => {
    const { locale, messages } =locales;
    return { locale, messages };
};

export default connect(mapStateToProps)(IntlProvider);